import React from 'react';
import RestrictedRoute from '../../../common/route/restrictedRoute';
import ComparisonReport from './ComparisonReport';
import { SALES_COMPARISONS } from './ComparisionReportConfig';

const ComparisonReportsRoutes = () => {
  return <RestrictedRoute
    exact
    key={SALES_COMPARISONS.reportName}
    reportName={SALES_COMPARISONS.reportName}
    reportTitle={SALES_COMPARISONS.reportTitle}
    path={SALES_COMPARISONS.urlPath}
    component={ComparisonReport}
  />;
};

export default ComparisonReportsRoutes;